import { TestCloudFunction } from "../../../../src/components/TestCloudFunctions.js";
import * as React from 'react';
export default {
  TestCloudFunction,
  React
};